Interactivid = window.Interactivid || {};

Interactivid.Utils = {

    /**
     * Get the most recently added Embed object on the page
     *
     * @returns {T}
     */
    getLastEmbed : function () {
        var embedList = document.getElementsByClassName('ep-embed');

        /*
         Take advantage of the fact that the embed we're interested in will
         be the last in the list since the function is called immediately
         after that embed is rendered.
         */
        return Array.prototype.slice.call(embedList).pop();
    },

    /**
     * Get the most recently added Player object on the page
     *
     * @returns {null}
     */
    getLastPlayer : function() {
        if(document['interactivid'] && document['interactivid'].length) {
            var len = document['interactivid'].length;
            return document['interactivid'][len-1]['player'];
        }
        return null;
    },

	/**
	 * Detect if the browser is a mobile device (phone, tablet)
	 * See https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
	 *
	 * @returns {boolean}
	 */
	isMobile : function() {
		var check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	},

    /**
     * Does JS element have this class
     *
     * @param el
     * @param selector
     * @returns {boolean}
     */
    hasClass : function(el, selector) {
        var className = " " + selector + " ";

        if ((" " + el.className + " ").replace(/[\n\t]/g, " ").indexOf(className) > -1) {
            return true;
        }
    },

    /**
     * Add an element to the end of the parent or before a specific element
     * 
     * @param {*} parent 
     * @param {*} innerHtml 
     * @param {*} isFirstChild 
     */
    addElement: function (parent, innerHtml, nextSibling) {
        var tmpParent = document.createElement('div');
        tmpParent.innerHTML = innerHtml;
        return nextSibling ? parent.insertBefore(tmpParent.firstChild, nextSibling) : parent.appendChild(tmpParent.firstChild);
    },

    /**
     * Encode parameters for an ajax request
     *
     * @param data
     * @param encoding
     * @returns {*}
     */
    encodeParams : function encodeParams(data, encoding) {

        var encoded,
            formEncode = function(data) {
                var pairs = [];
                for(var name in data) {
                    pairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
                }

                return pairs.join('&').replace(/%20/g, '+');
            };

        switch(encoding) {
            case 'form' :
                encoded = formEncode(data);
                break;
            case 'json' :
                encoded = JSON.stringify(data);
                break;
            default :
                console.warn('Unsupported encoding: '+encoding);
                return false;
        }

        return encoded;
    },

    /**
     * Simple convenience function to make an ajax request. Params can take :
     *
     * method : HTTP method (GET, PUT, etc.)
     * url : the target url
     * data : application data to be sent with request
     * onSuccess : function to be executed on success
     * onError : function to be executed on error
     *
     * @param params
     */
    ajax : function ajax(params) {

        // all query stuff should be encoded in url before it gets here
        var method = params.method || 'GET',
            url = params.url,
            data = params.data || {},
            onSuccess = params.onSuccess || function(r) {},
            onError = params.onError || function(r) {
                    console.error('Interactivid Error : %o', r);
                },
            request = new XMLHttpRequest({
                responseType : 'json'
            }),
            doJson = function() {
                return !(['POST','PUT','PATCH','DELETE'].indexOf(method) == -1 || Interactivid.Utils.isEmpty(data));
            };

        request.open(method, url, true);

        if(doJson()) {
            request.setRequestHeader('Content-Type', 'application/json');
        } else if(url.indexOf('?') > -1) {
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        }

        request.onreadystatechange = function () {
            if(request.readyState == 4) {

                if(request.status != 200) {
                    onError(request);
                    return false;
                }
                var response = JSON.parse(request.response);
                onSuccess(response);
            }
        };

        if(doJson()) {
            request.send(JSON.stringify(data));
        } else {
            request.send();
        }
    },

    /**
     * @param parent
     * @param className
     * @returns {*}
     */
    getChildByClass : function (parent, className) {

        for (var i = 0; i < parent.childNodes.length; i++) {
            if (parent.childNodes[i].nodeType == 1 && Interactivid.Utils.hasClass(parent.childNodes[i], className)) {
                return parent.childNodes[i];
            }
        }

        return null;
    },

    /**
     * Normalization for JS events : srcElement for IE, target for everything else
     *
     * @param event
     * @returns {*}
     */
    getEventTarget : function(event) {
        return event.target ? event.target : event.srcElement;
    },

    /**
     * Get the checked radio element
     *
     * @param radioName
     * @param container
     * @returns {*}
     */
    getCheckedRadio : function(radioName, container) {

        var elements = container.querySelectorAll('[name="'+radioName+'"]');

        if (elements.length) {
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].checked){
                    return elements[i];
                }
            }
        }

        return null;
    },

    /**
     * Get the checked radio element
     *
     * @param radioName
     * @param container
     * @returns {*}
     */
    getCheckedRadioIndex : function(radioName, container) {

        var elements = container.querySelectorAll('[name="'+radioName+'"]');

        if (elements.length) {
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].checked){
                    return i;
                }
            }
        }

        return null;
    },

    /**
     * Get the radio element by the specified index
     *
     * @param radioName
     * @param container
     * @returns {*}
     */
    getRadioByIndex : function(radioName, container, index) {

        var elements = container.querySelectorAll('[name="'+radioName+'"]');

        if (elements.length) {
        	if (typeof elements[index] !== 'undefined')
        		return elements[index];
        }

        return null;
    },

    /**
     * @param string
     * @returns {XML}
     */
    titleCase : function(string) {

        var cc = string
            .replace(/[\s_](.)/g, function($1) { return $1.toUpperCase(); })
            .replace(/[\s_]/g, '')
            .replace(/^(.)/, function($1) { return $1.toUpperCase(); });

        return cc;

        // return str.replace(/(?:^|\s)\w/g, function(match) {
        //     return match.toUpperCase();
        // });
    },

    /**
     * Converts hex to rgb. Useful for specifying colors with opacity.
     *
     * @param h
     * @param a
     * @returns {string}
     */
    hexToRgb : function hexToRgb(h, a)  {
        var r = parseInt((Interactivid.Utils.cuthex(h)).substring(0,2),16), g = parseInt((Interactivid.Utils.cuthex(h)).substring(2,4),16), b = parseInt((Interactivid.Utils.cuthex(h)).substring(4,6),16);
        return 'rgba(' + r +',' + g + ',' + b + ',' + a +')';
    },

    cuthex : function cuthex(h) {

        var start = h.charAt(0)=="#" ? 1 : 0;
        var hex = h.substring(start, h.length);

        if(hex.length == 3) {
            var full = '';
            for(var i=0; i<3; i++) {
                full += (hex[i] + hex[i]);
            }
            hex = full;
        }

        return hex;
    },

    /**
     * Determine whether a variable is 'empty' : null, undefined, empty string, empty array, empty object
     *
     * @param o
     * @returns {boolean}
     */
    isEmpty : function(o) {

        if(typeof o == null || typeof o == 'undefined') {
            return true;
        } else if(Array.isArray(o) || typeof o == 'string') {
            return o.length == 0;
        } else if(typeof o == 'object') {
            return Object.getOwnPropertyNames(o).length == 0;
        }
    },

    /**
     * Merge two JS objects
     *
     * @param o1
     * @param o2
     * @returns {*}
     */
    mergeObject : function(o1, o2) {
        for (var attrname in o2) {
            o1[attrname] = o2[attrname];
        }

        return o1;
    },

    /**
     * Given some custom data, generates generic JS event data object
     *
     * @param detail
     * @param bubbles
     * @param cancelable
     * @returns {{bubbles: *, cancelable: *, detail: (*|{})}}
     */
    eventParams : function(detail, bubbles, cancelable) {

        if(typeof bubbles == 'undefined') {
            bubbles = false;
        }

        if(typeof cancelable == 'undefined') {
            cancelable = true;
        }

        return {
            bubbles : bubbles,
            cancelable : cancelable,
            detail : detail || {}
        };
    },

    /*****************
     * Form Utils
     *****************/

    getFormInteractiveId : function getFormInteractiveId() {
        return getWrap().attr('data-ep-id');
    },

    getFormElementId : function getFormElementId(formObj) {
        return formObj.find('input[name="id"]').val();
    },

    getFormElementType : function getFormElementType(formObj) {
        return formObj.find('input[name="element_type"]').val();
    },

    isQuestionnaire : function isQuestionnaire(formObj) {
        var type = Interactivid.Utils.getFormElementType(formObj);
        return ['quiz','poll'].indexOf(type) > -1;
    },

	isLink : function isLink(formObj) {
		var type = Interactivid.Utils.getFormElementType(formObj);
		return (type == 'link');
	},

	isInteractiveform : function isInteractiveform(formObj) {
		var type = Interactivid.Utils.getFormElementType(formObj);
		return (type == 'interactiveform');
	},

    timelineToSliderValue : function(val, duration) {
        return val == 'end' ? parseInt(duration) : parseInt(val);
    },

    sliderToTimelineValue : function(val, duration) {
        return val == duration ? 'end' : val;
    },

	// TODO: Use this instead of the function in yt5.js? The display is different, but the function
	// could still be reused and formatting handled after the return.
	secondsToTime : function(seconds, forceHours, showMilliSeconds, returnArray) {
	    var mSeconds = "",
	        minutes,
	        hours,
	        floor = Math.floor;
	    if(showMilliSeconds) {
	        mSeconds = floor(seconds % 1 *1000);
	        mSeconds = "." + ('00' + mSeconds).slice(-3);
	    }
	    seconds = floor(seconds);
	    minutes = floor(seconds / 60);
	    if (minutes >= 60) {
	        hours = floor(minutes / 60);
	        minutes = minutes % 60;
	    } else {
	        hours = 0;
	    }
	    seconds = ('0' + floor(seconds % 60)).slice(-2);
	    minutes = (minutes >= 10 || (!forceHours && !hours)) ? minutes : "0" + minutes;
	    hours = ((hours > 0 || forceHours) ? hours + ":" :'');
	    if(returnArray) {
	        return [hours + minutes + ":" + seconds, mSeconds];
	    }
	    return hours + minutes + ":" + seconds + mSeconds;
	}
};

